import {Directive, ElementRef, HostListener, OnInit, inject} from '@angular/core';

@Directive({selector: 'input[appHideOnBlur]'})
export class HideOnBlurDirective implements OnInit {
  private elemRef = inject(ElementRef);


  private originalAttribute: string;

  @HostListener('blur')
  blur(): void {
    this.elemRef.nativeElement.setAttribute('type', 'password');
  }

  @HostListener('focus')
  focus(): void {
    this.elemRef.nativeElement.setAttribute('type', this.originalAttribute);
  }

  ngOnInit(): void {
    this.originalAttribute = this.elemRef.nativeElement.getAttribute('type');
  }

}
